<template>
<div class="goodsList">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleAdd">添加新商品</el-button>
            <el-button type="success" @click="handleCate">分类管理</el-button>
        </div>
        <div class="search">
            <el-input v-model="param.productname" placeholder="请输入商品名称" class="condition" clearable></el-input>
            <el-input v-model="param.catename" placeholder="请输入商品分类" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="subject" label="商品名称" width="300px" class-name="title">
                <template slot-scope="scope">
                    <div class="nameBox">
                        <img class="img" v-lazy="scope.row.coveratturlid" :alt="scope.row.productname"
                             preview="videoList"/>
                        <div class="imageText-summary">
                            <div class="textBox text-ellipses">
                                <div class="text">{{scope.row.productname}}</div>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="catename" label="分类名称" class-name="center"></el-table-column>
            <el-table-column prop="saleprice" label="销售价格" class-name="center"></el-table-column>
            <el-table-column prop="stockcount" label="商品库存" class-name="center"></el-table-column>
            <el-table-column prop="brokeragerate" label="商品佣金" class-name="center"></el-table-column>
            <el-table-column label="操作" width="250" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn">
                            <el-button @click="handleCopy(scope.row)" type="text" size="small">复制</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="refresh" ref="page"></page>
    </div>
    <cateListDialog ref="cateListDialog" @getList="_getList"></cateListDialog>
</div>
</template>

<script>
import {getEventProductList, deleteEventProductInfo, getProviderEventProductList, deleteProviderEventProductInfo} from 'api/brandBusiness'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import CateListDialog from 'views/brandBusiness/systemSetting/goodsBack/components/cateListDialog.vue'
import {initPage} from 'common/js/mixin'
export default {
    name: 'goodsList',
    mixins: [initPage],
    props: ['hostroletype'],
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            total: 0,
            tableData: [],
            power: [],
            param: {
                catename: '',
                fromsource: 1,
                hostroletype: 2,
                productname: '',
                rolehostid: '',
                status: ''
            }
        }
    },
    mounted() {
        if (!this.isRefresh) {
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
        }
    },
    activated() {
        if (this.isRefresh) {
            this.refresh()
            this.setIsRefresh(0)
        }
    },
    methods: {
        refresh() {
            if (this.isRefresh === 2) {
                this.param = {
                    catename: '',
                    fromsource: 1,
                    hostroletype: 2,
                    productname: '',
                    rolehostid: '',
                    status: ''
                }
                this.setPage({page: 1, pageSize: 10})
            }
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
        },
        handleCate() {
            this.$refs.cateListDialog.openDialog(this.hostroletype)
        },
        handleAdd() {
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this.$router.push({name: 'BBGoodsEdit', query: {fromSource: 1, hostroletype: this.hostroletype}})
            } else {
                this.$router.push({name: 'GBGoodsEdit', query: {fromSource: 1, hostroletype: this.hostroletype}})
            }
        },
        handleEdit(row) {
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this.$router.push({name: 'BBGoodsEdit', query: {productid: row.productid, fromSource: 1, hostroletype: this.hostroletype}})
            } else {
                this.$router.push({name: 'GBGoodsEdit', query: {productid: row.productid, fromSource: 1, hostroletype: this.hostroletype}})
            }
        },
        handleCopy(row) {
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this.$router.push({name: 'BBGoodsEdit', query: {productid: row.productid, fromSource: 1, hostroletype: this.hostroletype, iscopy: 1}})
            } else {
                this.$router.push({name: 'GBGoodsEdit', query: {productid: row.productid, fromSource: 1, hostroletype: this.hostroletype, iscopy: 1}})
            }
        },
        handleDel(row) {
            this.$confirm('确认删除该商品', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this._del(row)
                } else {
                    this._del2(row)
                }
            })
        },
        handleQuery() {
            this.setParams(this._.cloneDeep(this.param))
            this.$refs.page.handleSizeChange(1)
        },
        _del(obj) {
            this.setLoading(true)
            deleteEventProductInfo({
                data: Object.assign({}, {productid: obj.productid}),
                success: data => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _del2(obj) {
            this.setLoading(true)
            deleteProviderEventProductInfo({
                data: Object.assign({}, {productid: obj.productid}),
                success: data => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList2()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getEventProductList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList2() {
            this.setLoading(true)
            getProviderEventProductList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams',
            'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['page', 'user', 'isRefresh'])
    },
    components: {
        Page, CateListDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.goodsList {
    .nameBox {
        align-items: flex-start !important;
        display: flex;
        .img {
            min-width: 60px;
            width: 60px;
            height: 60px;
            margin-right: 16px;
            flex-shrink: 0;
            flex-grow: 0;
        }
        .imageText-summary {
            height: 60px;
            padding: 0 6px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            text-align: left;
            min-width: 104px;
        }
    }
}
</style>
